// Rendu d'un QR code SVG — entièrement local, sans service tiers (fonctionne hors ligne
// et sur un réseau local sans accès Internet). Toujours noir sur blanc : un QR code coloré
// perd du contraste et devient moins fiable à scanner avec un appareil photo de smartphone.
import qrcode from 'qrcode-generator';

/**
 * Dessine un QR code SVG redimensionnable dans `container` pour le texte donné.
 * @param {HTMLElement} container
 * @param {string} text
 */
export function renderQrCode(container, text) {
  const qr = qrcode(0, 'M'); // typeNumber 0 = taille automatique, correction d'erreur moyenne
  qr.addData(text);
  qr.make();
  container.innerHTML = qr.createSvgTag({ cellSize: 4, margin: 2, scalable: true });
  const svg = container.querySelector('svg');
  if (svg) svg.setAttribute('class', 'w-full h-full block');
}

/**
 * La matrice d'un QR code (mêmes réglages que `renderQrCode`), pour le dessiner soi-même (ex. sur un canvas).
 * @param {string} text
 * @returns {{ size: number, isDark: (row: number, col: number) => boolean }}
 */
export function qrMatrix(text) {
  const qr = qrcode(0, 'M');
  qr.addData(text);
  qr.make();
  return { size: qr.getModuleCount(), isDark: (row, col) => qr.isDark(row, col) };
}
